"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyTunables = void 0;
exports.assertModel = assertModel;
exports.createModel = createModel;
/**
 * v1's PhysicsModel: the object TrainerSim.m_model, GetConfig() and
 * convert.getPhysicsModel() return, built exactly as v1's setPhysicsModel
 * builds it, but as a fresh object per owner instead of one shared global.
 */
const freeze_1 = require("../engine/freeze");
const models_1 = require("../models");
const tableLimits_1 = require("../tableLimits");
const tableRPM2MPH_1 = require("../tableRPM2MPH");
const tableSpinAdjust_1 = require("../tableSpinAdjust");
const tableTrainerGeometry_1 = require("../tableTrainerGeometry");
const assert_1 = require("./assert");
const MPS_PER_MPH = 0.44704;
/** v1 setPhysicsModel's checks, in its order and with its messages. */
function assertModel(name, sport) {
    (0, assert_1.assert)(name in tableRPM2MPH_1.tableRPM2MPHMap, `no RPM2MPH mapping for physics model ${name}`);
    (0, assert_1.assert)(sport in tableRPM2MPH_1.tableRPM2MPHMap[name], `no RPM2MPH mapping for physics model ${name}, sport ${sport}`);
    (0, assert_1.assert)(name in tableLimits_1.tableLimitsMap, `no physicsModelName limits mapping for physics model ${name}`);
    (0, assert_1.assert)(sport in tableLimits_1.tableLimitsMap[name], `no physicsModelName limits mapping for physics model ${name}, sport ${sport}`);
    (0, assert_1.assert)(sport in models_1.CourtGeometryBySport, `no court geometry mapping for sport ${sport}`);
    (0, assert_1.assert)(name in tableTrainerGeometry_1.tableTrainerGeometryMap, `no trainer geometry mapping for physics model ${name}`);
    (0, assert_1.assert)(name in tableSpinAdjust_1.tableSpinAdjustMap, `no spin adjustment mapping for physics model ${name}`);
    (0, assert_1.assert)(sport in tableSpinAdjust_1.tableSpinAdjustMap[name], `no spin adjustment mapping for sport ${sport}`);
}
/** v1's MPS limits, derived from the RPM limits through the speed table. */
function mpsLimits(name, sport) {
    const mph = tableRPM2MPH_1.tableRPM2MPHMap[name][sport];
    const rpm = tableLimits_1.tableLimitsMap[name][sport].RPM;
    return {
        limit: mph[rpm.limit] * MPS_PER_MPH,
        maxSafe: mph[rpm.maxSafe] * MPS_PER_MPH,
        minSafe: mph[rpm.minSafe] * MPS_PER_MPH,
    };
}
/** A model for a trainer and sport, holding `tunables` as its own. */
function createModel(name, sport, tunables) {
    return {
        name,
        sport,
        ballParams: tunables.ballParams,
        mapRPM2MPH: tableRPM2MPH_1.tableRPM2MPHMap[name][sport],
        simParams: tunables.simParams,
        trainerGeometry: (0, freeze_1.clonePlainData)(tableTrainerGeometry_1.tableTrainerGeometryMap[name]),
        constants: tunables.constants,
        limits: { RPM: { ...tableLimits_1.tableLimitsMap[name][sport].RPM }, MPS: mpsLimits(name, sport) },
        courtGeometry: { ...models_1.CourtGeometryBySport[sport] },
        spinAdjust: tableSpinAdjust_1.tableSpinAdjustMap[name][sport],
    };
}
/** Copies of a model's tunables, for a model that must not share them. */
const copyTunables = ({ ballParams, constants, simParams }) => ({
    ballParams: { ...ballParams },
    constants: { ...constants },
    simParams: { ...simParams },
});
exports.copyTunables = copyTunables;
